/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contacts_Edit_TitleInputs */

const cs_contacts_edit_title = /** @type {(inputs: Contacts_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit kontakty`)
};

const en_contacts_edit_title = /** @type {(inputs: Contacts_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit contacts`)
};

/**
* | output |
* | --- |
* | "Edit contacts" |
*
* @param {Contacts_Edit_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contacts_edit_title = /** @type {((inputs?: Contacts_Edit_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contacts_Edit_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contacts_edit_title(inputs)
	return cs_contacts_edit_title(inputs)
});